<script lang="ts" setup>
  import HostErrorMessage from './HostErrorMessage.vue';
</script>

<template>
  <HostErrorMessage title="The Spotify device is inactive">
    <p>To host a Songstar game, your Spotify device must be active and playing music, before signing in.</p>
    <ol>
      <li>Connect your phone or preferred device to a speaker (E.G. via Bluetooth)</li>
      <li>Start playing music on spotify with a volume every participant can hear clearly</li>
      <li>Try signing in again</li>
    </ol>
  </HostErrorMessage>
</template>
